/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 * @param  {String} name  The name of the cookie
 * @return {String}       The cookie value
 */
const getCookie = (name) => {
	let value = `; ${document.cookie}`;
	let parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
}

/**
 * Check if the cookie exists and if so add a class to the plugin app to show this
 * Timeout added whilst tghe plugin is embedded
 */
const cookieCheck = () => {
  setTimeout(() => {
    const gorgiasButton = document.querySelector('#gorgias-chat-container');
    const cookie = getCookie('eg_cookieconsent_status');
    if (cookie) {
      gorgiasButton.classList.add('gorgias-chat-container');
      gorgiasButton.classList.remove('cookie-banner-active');
    } else {
      gorgiasButton.classList.add('gorgias-chat-container', 'cookie-banner-active');
    }
}, 250);
}

/**
 * Work the above function when you click on the Gorgias button
 */
const cookieHide = () => {
  document.addEventListener('click', e => {
    if (e.target.matches('.eg-cc-dismiss')) {
      cookieCheck();
    }
  })
}

export const gorgias = () => {
  cookieCheck();
  cookieHide();
}